var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"base"},[_c('dropzone',{ref:"dropzone",attrs:{"id":_vm.id,"options":_vm.options},on:{"vdropzone-file-added":_vm.onFileAdded,"vdropzone-removed-file":_vm.onRemovedFile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }